'use client';

import { twMerge } from '@shared/themes';
import { RenewalErrorNotification } from '../../RenewalErrorNotification/RenewalErrorNotification';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsRenewalErrorProps = {
  className?: string;
};

/**
 * Renders the renewal error notification when the latest renewal failed.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsRenewalError({ className }: PurchaseDetailsRenewalErrorProps) {
  const { ticket } = usePurchaseDetails();
  const errorCode = ticket.latestRenewal?.errorCode;

  if (!errorCode) return null;

  return <RenewalErrorNotification errorCode={errorCode} className={twMerge('ll-container-inner', className)} />;
}

export { PurchaseDetailsRenewalError, type PurchaseDetailsRenewalErrorProps };
